import React, {useState} from "react";
import BotApi from "../../apis/ChatBotApi";

interface Message {
  id: number;
  texte: string;
  auteur: "user" | "bot" | "form";
}

interface ChatFormProps {
  messages: Message[];
}

function ChatForm({messages}: ChatFormProps) {
  const [handleMail, setHandleMail] = useState<Boolean>(false);
  const [email, setEmail] = useState<String>();
  const [consoleID, setConsoleID] = useState<String>();
  const [phoneNumber, setPhoneNumber] = useState<String>();
  const [orderId, setOrderId] = useState<String>();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {name, value} = e.target;
    switch (name) {
      case "email":
        setEmail(value);
        break;
      case "consoleID":
        setConsoleID(value);
        break;
      case "phoneNumber":
        setPhoneNumber(value);
        break;
      case "orderId":
        setOrderId(value);
        break;
      default:
        break;
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    try {
      BotApi.sendMail(
        email as string,
        messages as Message[],
        consoleID as string,
        phoneNumber as string,
        orderId as string
      );
      setHandleMail(true);
    } catch (error) {
      console.error("Erreur lors de l'envoi du mail :", error);
    }
  };

  return (
    <div className="flex justify-start">
      <div className="bg-white rounded-xl shadow-lg p-4 w-full max-w-sm border border-gray-200">
        {handleMail ? (
          <div className="text-center flex justify-around items-center">
            <h2 className="text-lg font-semibold mb-4 text-[#405dae]">
              Merci ! Votre message a été envoyé avec succès.
            </h2>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            {/* Email */}
            <div>
              <label
                htmlFor="resume"
                className="block text-sm font-medium text-gray-700">
                Adresse Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={email as string}
                onChange={handleChange}
                className="mt-1 block w-full rounded-lg border border-gray-300 p-2 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                placeholder="Votre email"
                required
              />
            </div>

            {/* Console ID */}
            <div>
              <label
                htmlFor="websiteUrl"
                className="block text-sm font-medium text-gray-700">
                Identifiant de console (optionel)
              </label>
              <input
                type="text"
                id="consoleID"
                name="consoleID"
                value={consoleID as string}
                onChange={handleChange}
                className="mt-1 block w-full rounded-lg border border-gray-300 p-2 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                placeholder="Votre console ID"
              />
            </div>

            {/* Téléphone */}
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700">
                Numéro de téléphone (optionel)
              </label>
              <input
                type="text"
                id="phoneNumber"
                name="phoneNumber"
                value={phoneNumber as string}
                onChange={handleChange}
                className="mt-1 block w-full rounded-lg border border-gray-300 p-2 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                placeholder="Votre numéro de téléphone"
              />
            </div>

            {/* Commande */}
            <div>
              <label
                htmlFor="name"
                className="block text-sm font-medium text-gray-700">
                Numéro de commande (optionel)
              </label>
              <input
                type="text"
                id="orderId"
                name="orderId"
                value={orderId as string}
                onChange={handleChange}
                className="mt-1 block w-full rounded-lg border border-gray-300 p-2 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                placeholder="Votre numéro de commande"
              />
            </div>

            <div className="flex justify-between items-center pt-2">
              <button
                type="submit"
                className="bg-[#405dae] text-white font-semibold py-2 px-4 rounded-3xl shadow-md hover:bg-[#2c4c91] hover:color-[#fbfbfb]">
                Envoyer
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default ChatForm;
